import React from 'react'
import './Virtual.css'
import Shade from '../../assets/shade.png'
import CompareImage from "react-compare-image";
import before from '../../assets/before.png'
import after from '../../assets/after.png'
const Virtual = () => {
  return (
    <div className='virtual'>
      <div className="left-side">
        <span>Virtual Try-On</span>
        <span>Never Buy the wrong shade Again!</span>
        <span>Try Now!</span>
        <img src={Shade} alt=""/>
      </div>

      <div className="right-side">
        <div className="wrapper">
          <CompareImage leftImage={before} rightImage={after}/>
        </div>
      </div>
    </div>
  )
}
 
export default Virtual